<template>
  <div id="testimonialOne"></div>
</template>

<script>
export default {
  name: "TestimonialOne",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        quote:
          "This product completely transformed how we work. The results speak for themselves.",
        name: "Sarah Johnson",
        role: "Head of Marketing",
        company: "TechCorp Inc.",
        rating: 5,
        chip: "Customer Story",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    isDarkColor(color) {
      let r, g, b;
      if (color.startsWith("#")) {
        const hex = color.slice(1);
        if (hex.length === 3) {
          r = parseInt(hex[0] + hex[0], 16);
          g = parseInt(hex[1] + hex[1], 16);
          b = parseInt(hex[2] + hex[2], 16);
        } else {
          r = parseInt(hex.substring(0, 2), 16);
          g = parseInt(hex.substring(2, 4), 16);
          b = parseInt(hex.substring(4, 6), 16);
        }
      } else {
        const rgb = color.match(/\d+/g);
        if (!rgb || rgb.length < 3) return false;
        r = parseInt(rgb[0]);
        g = parseInt(rgb[1]);
        b = parseInt(rgb[2]);
      }
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness < 128;
    },
    render() {
      const el = document.getElementById("testimonialOne");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const quoteSize = exporting ? 52 : 52 * this.scale;
      const nameSize = exporting ? 32 : 32 * this.scale;
      const roleSize = exporting ? 24 : 24 * this.scale;
      const logoHeight = exporting ? 50 : 50 * this.scale;
      const chipSize = exporting ? 24 : 24 * this.scale;
      const starSize = exporting ? 28 : 28 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#000000";

      const rating = this.data.rating || 5;
      const starsHtml = Array(5)
        .fill(0)
        .map(
          (_, i) => `
        <span style="color: ${i < rating ? "#fbbf24" : "#d1d5db"}; font-size: ${starSize}px;">★</span>
      `,
        )
        .join("");

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background-color: #f5f5f5;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
          "
        >
          <div style="padding: 10%">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" />
          </div>

          <div style="padding: 0 10%;">
            <div style="margin-bottom: 24px;">${starsHtml}</div>
            <div style="border-left: 6px solid #272727; padding-left: 25px;">
              <div style="
                font-size: ${quoteSize}px;
                font-weight: 400;
                color: #272727;
                line-height: 1.4;
                margin-bottom: 32px;
              ">"${this.data.quote}"</div>
            </div>
            <div style="padding-left: 31px;">
              <p style="color: #272727; font-size: ${nameSize}px; margin: 0; font-weight: 600;">
                ${this.data.name}
              </p>
              <p style="color: #737373; font-size: ${roleSize}px; margin: 6px 0 0 0;">
                ${this.data.role}${this.data.company ? ` at ${this.data.company}` : ""}
              </p>
            </div>
          </div>

          <div style="padding: 10%">
            <div style="display: flex;">
              <span
                style="
                  display: inline-block;
                  background: ${primaryColor};
                  color: ${this.isDarkColor(primaryColor) ? "#fff" : "#000"};
                  font-size: ${chipSize}px;
                  font-weight: 500;
                  border-radius: 999px;
                  padding: 7px 22px;
                  letter-spacing: 0.03em;
                  font-family: 'Inter', Arial, sans-serif;
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style scoped></style>
